var exports = {
  "DR": "Box_0__MXTx27",
  "wy": "Box_1__-HY47R",
  "pv": "Box_2__WoSDrj",
  "w9": "Box_3__34R-B-",
};

module.exports = exports;
